<template>
    <div>
        <b-card>
            <span style="font-size: 2rem; font-weight: 500;">{{step_data.step_name}}</span>
            
            <form-wizard shape="square" ref="step-wizard" @on-change="onChange" @on-complete="onComplete" color="#556ee6">
                    <tab-content :before-change="tabChange" v-for="view in step_data.spreadify_views" :key="view.id" :icon="`mdi mdi-numeric-${view.render_order}-box-multiple`">
                            <form-plugin 
                            :viewFile="clientMediaFile(view.spreadify_uid)"
                            :step="step_data.render_order"
                            @hasLoaded="has_form_loaded = true"
                            @downloadFile=processFileDownload
                            @uploaderData="processUpload"
                            @formDataUpdated="updateFormData"
                            :viewData="step_form_data"
                            :uid="view.spreadify_uid"></form-plugin>
                    </tab-content>
                </form-wizard>
            <b-button v-if="has_form_loaded" @click="save" variant="success">
            Save</b-button>
        </b-card>
        <DownloadModal v-if="showDownloadModal == true" />
    </div>
</template>

<script>
import DownloadModal from '@/components/client/downloadModal.vue'
import { FormWizard, TabContent } from "vue-form-wizard";
import Uploader from 'simple-uploader.js'
//eslint-disable-next-line
import _ from 'lodash'
import { licenseAppState, licenseAppMethods } from '@/state/helpers'
export default {
    components: { 
        FormWizard, TabContent,DownloadModal
    },
    data:() => ({
        showDownloadModal: false,
        has_form_loaded: false,
        current_form_data: [],
        params:{},
        hasSaved: false,
        current_index: 0,
    }),
    computed:{
        ...licenseAppState,
        step_form_data(){
            return this.step_data.spreadify_views[this.current_index].form_data
        },
        step_uid(){
            return this.step_data.spreadify_views[this.current_index].spreadify_uid
        },
    },
    methods:{
        ...licenseAppMethods,
        /*updateFormData(newData){
            //*event fired from <form-plugin>
            this.current_form_data = newData.data;
        },*/
        updateFormData(newData){
            //*event fired from <form-plugin>
            let step_index = _.findIndex(this.step_data.spreadify_views, {spreadify_uid: newData.uid})
            if(step_index > -1){
                let view = this.step_data.spreadify_views[step_index];
                let index = view.render_order - 1;
                this.current_form_data[index] = newData.data;
            }
        },

        processUpload(file){
            //* Uploader event method
            let storage = window.localStorage;
            let AUTH_TOKEN = storage.getItem('x_token');
            let uploader = new Uploader({
                target: process.env.VUE_APP_API_BASEURL + 'api/licenseapp/uploadmedia',
                headers: {
                    'Authorization': 'Bearer ' + AUTH_TOKEN,
                },
                query:{/* '612f6171f003b',*/
                    step_id : this.step_data.id,
                    spreadify_uid : this.step_uid,
                    key : 'document_file',
                },
                testChunks: false,
                fileParameterName: 'file', //Set the upload post param which will contain the binary payload
                singleFile: false, //Limit upload to one file
            });
            //eslint-disable-next-line
            uploader.on('fileComplete', function (rootFile) {
                this.$swal.fire({ toast: true, position: 'top', iconColor: 'white', icon: 'success', title:'File Uploaded', customClass: {     popup: 'success-toast' }, showConfirmButton: false, timer: 2000, timerProgressBar: true});
            });
            //eslint-disable-next-line
            uploader.on('fileAdded', function (file, event) {
                console.log('fileAdded', file);
            });

            this.$nextTick(()=>{
                if(file.length == undefined){
                    uploader.addFile(file);
                    this.$nextTick(()=>{
                        uploader.upload();
                    });
                }
                else if(file.length){
                    for(let i = 0; i < file.length; i++ ){
                        uploader.addFile(file[i]);
                    }
                    this.$nextTick(()=>{
                        uploader.upload();
                    });
                }
                

                //! old code 
                /*
                uploader.addFile(file);
                this.$nextTick(()=>{
                    uploader.upload();
                })
                */
            });
        },
        processFileDownload(params){
            this.showDownloadModal = true;
            this.$nextTick(()=>{
                this.$bvModal.show('downloadModal');
                this.$root.$once('bv::modal::hidden',(event)=>{
                    if(event.type == 'hidden' && event.componentId == 'downloadModal'){
                        this.showDownloadModal = false;
                    }
                })
                this.getDownloadLink(params)
                .then(response => {
                    this.$eventHub.$emit('setDownloadUrl', response);
                })
            })
        },
        clientMediaFile(uid){
            let files = [];
            this.step_data.client_uploads.forEach((file) => {
                if(file.spreadify_uid == uid){
                    files.push(file);
                }
            });
            return files;
        },
        save(){
            this.$emit('back', this.step_data.id);
        },
        //eslint-disable-next-line
        onChange(previous, next){
            this.current_index = next;
            //alert(`From ${previous} to ${next}`);
        },
        onComplete(){
            this.isSaving = true;
            this.params.form_data = this.params.form_data.filter(Boolean);

            this.saveFormData(this.params)
            .then(()=>{
                this.isSaving = false;
                this.requestStepApproval(this.step_data.id)
                .then(()=>{
                    this.$swal.fire({ toast: true, position: 'top', iconColor: 'white', icon: 'success', title:'Success', customClass: {     popup: 'success-toast' }, showConfirmButton: false, timer: 2000, timerProgressBar: true});
                    this.$emit('back', this.step_data.id);
                })
                .catch(()=>{ console.log('Error submitting final form')})
            })
            .catch(()=>{
                setTimeout(()=>{
                    this.isSaving = false;
                    alert('Approval Request Error');
                }, 500)
            })
        },
        tabChange(){
            
            return true;
        },
    },
    mounted(){
        this.params = {
            step_id: this.step_data.id,
            form_data:[],
        }
        //* Activate all steps
        this.$refs['step-wizard'].activateAll();
    },
    beforeDestroy(){
        //*Fetch new data for the status bar and project timeline table
        if(this.hasSaved){
            this.loadAppData();
        }
    }
}
</script>

<style>

</style>